import styled from "styled-components"

import {Label} from "@irati/ui/src/FormItem"
import padding from "@irati/ui/src/global/padding"
import {LatoBold} from "@irati/ui/src/global/fonts"


export default styled(Label)`
  margin-bottom: ${padding.tiny};
  ${({flush}) => flush && "margin-bottom: 0"};
  ${({bold}) => bold && LatoBold}
`
